import type { DashboardDataModel, DashboardDataResponse } from '@/domain/models/dashboard.js';
import { DashboardDataModel as DashboardDataModelClass } from '@/domain/models/dashboard.js';
import type { HttpClient } from '@/domain/protocols/http-client.js';
import type { DashboardRepository } from '@/domain/repositories/dashboard-repository.js';

export class DashboardRepositoryImpl implements DashboardRepository {
    constructor(private readonly httpClient: HttpClient) {}

    public async load(params?: DashboardRepository.LoadParams): Promise<DashboardDataModel> {
        const qs = params?.projectId ? `?projectId=${encodeURIComponent(params.projectId)}` : '';
        const response = await this.httpClient.request<DashboardDataResponse>({ url: `/api/dashboard${qs}`, method: 'GET' });
        return DashboardDataModelClass.withFromResponse(response.body);
    }
}
